import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import { components } from 'react-select'

const MenuComponentWithWidth = ({ className, ...rest }) => {
  const classes = useStyles(rest)

  return (
    <div>
      <div>
        <div className={classes.menuTopBorder}></div>
      </div>
      <components.Menu className={clsx(className, classes.menu)} {...rest} />
    </div>
  )
}

MenuComponentWithWidth.propTypes = {
  className: PropTypes.string,
  // all Props from Menu
}

const useStyles = makeStyles(theme => ({
  menu: (props) => ({
    '&&': ({
      minWidth: props.selectProps.menuWidth,
      borderTop: `1px solid ${theme.activeInputBorder}`,
    }),
  }),
  menuTopBorder: {
    position: 'absolute',
    width: 'calc(100% - 2px)',
    height: 1,
    zIndex: 6,
    background: theme.white,
    marginTop: -4,
    marginLeft: 1,
    marginRight: 0,
  },
}))

export default MenuComponentWithWidth
